export default __webpack_public_path__ + "static/media/wholesale_sellersCo_logo.e4382b7c.png";